import React from "react";
import { withTranslation } from "react-i18next";

import { COMMUNICATION_CHANNELS } from "../../../../../../util/communication_statuses";
import { getCommunicationChannelIcon, getCommunicationChannelName } from "../../../../util/communication_channels";

import "./index.scss";

const PreferredCommunicationChannel = ({ settings, preferredCommChannel, onSetPreferredCommChannel, t }) => {
  const channels = [COMMUNICATION_CHANNELS.EMAIL];

  if (settings.has_sms) channels.push(COMMUNICATION_CHANNELS.SMS);
  if (settings.has_whats_app) channels.push(COMMUNICATION_CHANNELS.WHATSAPP);

  return (
    <div className="PreferredCommunicationChannelContainer">
      <div className="PreferredCommunicationChannel">
        <div className="PreferredCommunicationChannel__Header">{t("cc_select_preferred_communication_channel").message || "Select Preferred Communication Channel"}</div>
        <div className="PreferredCommunicationChannel__Content">
          {channels.map(channel => (
            <button
              key={channel}
              type="button"
              className={`preferred-channel-button ${preferredCommChannel === channel ? "preferred-channel-button--active" : ""}`}
              onClick={() => onSetPreferredCommChannel(channel)}
            >
              {getCommunicationChannelIcon(channel, "preferred-channel-icon")}
              <span>{getCommunicationChannelName(channel, t)}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(PreferredCommunicationChannel);
